/**
 * Automations (the automation engine module) — routing-map keys for the
 * breadcrumb titles of its list pages. The module's own URL builders live in
 * `src/modules/automation/paths.ts` (a test there holds the base in step);
 * detail paths (`/:id`, `/new`) are composed by the module's route table.
 */
import React from 'react'
import { T } from '@transifex/react'

import { ApprovalCrumbTitle } from 'src/modules/automation/approvalCrumb'
import { pathJoin } from 'src/reducers/routing/utils'

export const createAutomationsRoutesMap = (prefix: string) => ({
  templates: pathJoin(prefix)('templates').chainWithTitle({
    title: <T _str="Templates" />,
    breadCrumbTitle: <T _str="Templates" />,
  }),
  activity: pathJoin(prefix)('activity').chainWithTitle({
    title: <T _str="Activity" />,
    breadCrumbTitle: <T _str="Activity" />,
  }),
  // `/approvals/<id>` reads "Approvals / <the approval's plain title>", not
  // "Approvals / Approvals" (the title is published by the detail page)
  approvals: pathJoin(prefix)('approvals').chainMapAuto(
    (approvalsPrefix) => ({
      ':id': (id = ':id') =>
        pathJoin(approvalsPrefix)(id).chainWithTitle({
          title: <ApprovalCrumbTitle />,
          breadCrumbTitle: <ApprovalCrumbTitle />,
        }),
    }),
    {
      title: <T _str="Approvals" />,
      breadCrumbTitle: <T _str="Approvals" />,
    }
  ),
  attention: pathJoin(prefix)('attention').chainWithTitle({
    title: <T _str="Needs attention" />,
    breadCrumbTitle: <T _str="Needs attention" />,
  }),
  settings: pathJoin(prefix)('settings').chainWithTitle({
    title: <T _str="Settings" />,
    breadCrumbTitle: <T _str="Settings" />,
  }),
})
